import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';
import { Box, Typography } from '@material-ui/core';

import { Translation } from '../../common';

const useStyles = makeStyles(() => ({
  text: {
    marginTop: 16
  }
}));

const Welcome = ({ className, textClassName, isPaidFully }) => {
  const classes = useStyles();

  return (
    <Box className={className}>
      <Typography component="h2" variant="h3" color="secondary">
        <Translation isHtml inline id="welcome-greeting-title">
          MAIN_SALUTATION
        </Translation>
      </Typography>
      <Typography
        variant="body1"
        color="textPrimary"
        className={classNames(classes.text, textClassName)}
      >
        <Translation inline isHtml id="welcome-greeting-message">
          {isPaidFully ? 'MAIN_PAID' : 'MAIN'}
        </Translation>
      </Typography>
    </Box>
  );
};

Welcome.propTypes = {
  className: PropTypes.string,
  isTabletSize: PropTypes.bool
};

export default Welcome;
